<template>
  <v-row class="align-center mb-3" id="titleAndSearch">
    <v-col md="auto">
      <div class="d-flex align-center my-1">
        <SvgIcon
          class="secondary--text mr-3"
          :width="30"
          :height="30"
          :iconType="icon"
        />
        <div class="titleAndSearch__title secondary--text font-weight-bold">
          {{ title }}
        </div>
      </div>
    </v-col>
    <v-col
      :md="searchSize"
      :class="{ 'ml-auto': true }"
      :offset-md="0"
      v-if="showSearch"
    >
      <v-text-field
        hide-details
        :label="
          $t('fleet_management.entities.items_header.labels.label_search_input')
        "
        v-model="searchTermInput"
        @keyup="search"
        @keyup.enter="executeSearch"
        class="pt-0 mt-0"
        @focus="onSearchTermInputFocus()"
      >
        <template v-slot:append class="mt-0">
          <div>
            <span v-if="totalMatches > 0"
              >{{ matchPosition }}/{{ totalMatches }}</span
            >
            <span v-else-if="searchTerm.length > 0 && totalMatches == 0"
              >0/0</span
            >
            <v-btn
              :disabled="totalMatches > 0 ? false : true"
              icon
              @click="decrease"
            >
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn
              :disabled="totalMatches > 0 ? false : true"
              icon
              @click="increase"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import { mapActions, mapGetters } from 'vuex'
import { firebaseServices } from '@leapsight/styleguide'
export default {
  name: 'ItemsHeader',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showSearch: {
      type: Boolean,
      required: true
    },
    searchSize: {
      type: Number,
      //Tamaño default que ocupara la columna que contiene el input search
      default: 4
    },
    searchTermInputReset: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SvgIcon
  },
  data() {
    return {
      searchTerm: '',
      matchPosition: 1,
      totalMatches: 0
    }
  },
  methods: {
    ...mapActions(['setSearch', 'setMatchPosition']),
    search() {
      this.resetPosition()
      this.setSearch(this.searchTerm)
    },
    matchCounter(value) {
      this.totalMatches = value.length
    },
    increase() {
      if (this.matchPosition == this.totalMatches) {
        this.matchPosition = 1
      } else {
        this.matchPosition++
      }
    },
    decrease() {
      if (this.matchPosition == 1) {
        this.matchPosition = this.totalMatches
      } else {
        this.matchPosition--
      }
    },
    resetPosition() {
      this.matchPosition = 1
    },
    executeSearch() {
      this.resetPosition()
      this.setSearch(this.searchTerm)
      this.$store.dispatch('reports/filterReportsByString', {
        string: this.searchTermInput
      })
    },
    onSearchTermInputFocus() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        'inp_informe_buscar'
      )
    }
  },
  computed: {
    ...mapGetters(['getSearchMatch']),
    searchTermInput: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.searchTerm = value.toLowerCase()
      }
    }
  },
  watch: {
    getSearchMatch() {
      const matches = this.getSearchMatch
      this.matchCounter(matches)
    },
    matchPosition() {
      this.setMatchPosition(this.matchPosition)
    },
    searchTerm(string) {
      this.$store.dispatch('reports/filterReportsByString', { string })
    },
    searchTermInputReset(newValue) {
      if (newValue) {
        this.searchTermInput = ''
        this.setSearch(this.searchTerm)
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
#titleAndSearch {
  .titleAndSearch__title {
    font-size: 1.375rem;
  }
}
</style>
